import { createSelector } from 'reselect';

import {
  selectEntitiesMissionsEntityEndDate,
  selectEntitiesMissionsEntityStartDate,
} from '../../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { Selector } from '../../../../types/selectors';

type MissionTimerContainerPropsType = {
  startDate?: number;
  endDate?: number;
};

const selectMissionTimerContainerProps: Selector<MissionTimerContainerPropsType> = createSelector(
  [selectEntitiesMissionsEntityStartDate, selectEntitiesMissionsEntityEndDate],
  (startDate, endDate) => ({
    startDate,
    endDate,
  }),
);

export default selectMissionTimerContainerProps;
